let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("UFKY9")).then(() => parcelRequire('7niOW'));